import { Fragment } from 'react';
import css from './index.module.scss';
import { getuuid } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { specGeneralKeyMap } from '@/config/generalKeyMap';

export default function OverView({ productCatagoryData, theme = '', ...rest }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <div className={`${css.productDetailWrapper} product_overview ${css[theme === 'black' ? 'theme_black' : 'theme_white']} container`} {...rest}>
            {productCatagoryData?.map((item: any, i: any) => (
                <div className={i > 2 ? 'detail-box single-item' : 'detail-box'} key={getuuid()}>
                    {item?.arrayList?.length > 0 &&
                        !(
                            item?.arrayList?.length === 1 &&
                            item?.generalKey?.toLowerCase() === specGeneralKeyMap['specs_what_in_the_box'] &&
                            (item?.arrayList[0]?.value === '–' || (!item?.arrayList[0]?.value && String(item?.arrayList[0]?.value) !== 'false'))
                        ) && (
                            <ul>
                                <li>
                                    <div className="title">
                                        <strong className="font-family-semibold">{item.name}</strong>
                                    </div>
                                </li>
                                <li className="contents">
                                    {item?.arrayList?.map((list: any) => {
                                        // falg: 中东站因为全局direction: rtl， 但是spec中并不是所有的需要rtl，所以有部分需要ltr
                                        const flag = locale === 'sa' && !Array.isArray(list.value) && String(list?.value).endsWith(' [* *]');
                                        if (flag) {
                                            list.value = String(list.value)?.split(' [* *]')[0];
                                            list.class = 'ltr';
                                        }
                                        return (
                                            <Fragment key={getuuid()}>
                                                {/* 双品数据 */}
                                                {Array.isArray(list.value) &&
                                                    list.value.length >= 2 &&
                                                    list.value.map((items: any, j: any) => {
                                                        if (items) {
                                                            const flag2 = locale === 'sa' && String(items).endsWith(' [* *]');
                                                            if (flag2) {
                                                                items = String(items)?.split(' [* *]')[0];
                                                            }
                                                            return (
                                                                <p key={getuuid()} className={list.value.length > 2 ? 'double-p' : 'double-p'}>
                                                                    {list.generalKey.toLowerCase() !== specGeneralKeyMap['specs_what_in_the_box'] && (
                                                                        <strong className="font-family-semibold">
                                                                            {items && (items !== '–' ? list.key : ' ')}
                                                                        </strong>
                                                                    )}
                                                                    {list.generalKey.toLowerCase() === specGeneralKeyMap['specs_what_in_the_box'] && (
                                                                        <span
                                                                            className={`lastbox specValue ${flag2 ? 'ltr' : ''}`}
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: items !== '–' ? items.replace(/\n/g, '<br/>') : ' ',
                                                                            }}
                                                                        ></span>
                                                                    )}
                                                                    {list.generalKey.toLowerCase() !== specGeneralKeyMap['specs_what_in_the_box'] && (
                                                                        <span
                                                                            className={`specValue ${flag2 ? 'ltr' : ''}`}
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: items !== '–' ? items.replace(/\n/g, '<br/>') : ' ',
                                                                            }}
                                                                        ></span>
                                                                    )}
                                                                </p>
                                                            );
                                                        }
                                                    })}
                                                {/* 单品数据 */}
                                                {!Array.isArray(list.value) && list.value && list.value !== '–' && (
                                                    <p
                                                        key={getuuid()}
                                                        className={
                                                            list.generalKey.toLowerCase() !== specGeneralKeyMap['specs_what_in_the_box'] ? '' : 'allwidth'
                                                        }
                                                    >
                                                        {list.generalKey.toLowerCase() !== specGeneralKeyMap['specs_what_in_the_box'] && (
                                                            <strong className="font-family-semibold">{list.value && list.key}</strong>
                                                        )}
                                                        {list.generalKey.toLowerCase() === specGeneralKeyMap['specs_what_in_the_box'] && (
                                                            <span
                                                                className={`lastbox specValue ${list?.class}`}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: list.value.replace(/\n/g, '<br/>'),
                                                                }}
                                                            ></span>
                                                        )}
                                                        {list.generalKey.toLowerCase() !== specGeneralKeyMap['specs_what_in_the_box'] && (
                                                            <span
                                                                className={`specValue ${list?.class ?? ''}`}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: list.value.replace(/\n/g, '<br/>'),
                                                                }}
                                                            ></span>
                                                        )}
                                                    </p>
                                                )}
                                            </Fragment>
                                        );
                                    })}
                                </li>
                            </ul>
                        )}
                </div>
            ))}
        </div>
    );
}
